import { AIconSize } from '../../atoms/AIcon/AIcon.types';
import { ASubheaderSize } from '../../atoms/ASubheader/ASubheader.types';
import { ABodySize, ABodyColor } from '../../atoms/ABody/ABody.types';

export const DEFAULT_ICON_SIZE = AIconSize.XXL;
export const DEFAULT_SUBHEADER_SIZE = ASubheaderSize.XL;
export const DEFAULT_BODY_SIZE = ABodySize.S;
export const DEFAULT_BODY_COLOR = ABodyColor.Alternate;

export const toBoolean = (value: boolean | string | null | undefined): boolean =>
  typeof value === 'boolean' ? value : String(value).toLowerCase() === 'true';

/**
 * Resolves an AEM size string to an enum value. Matches enum keys longest-first
 * so "XXL (40x40)" resolves to XXL rather than XL or L.
 */
export const resolveEnumSize = <T extends Record<string, string>>(
  size: string | null | undefined,
  enumObj: T,
  fallback: T[keyof T]
): T[keyof T] => {
  if (!size) return fallback;

  if (Object.values(enumObj).includes(size)) return size as T[keyof T];

  const keys = Object.keys(enumObj).sort((a, b) => b.length - a.length);
  const upper = size.toUpperCase();
  const matchedKey = keys.find(key => upper.startsWith(key.toUpperCase()));

  return matchedKey ? (enumObj[matchedKey] as T[keyof T]) : fallback;
};

export const resolveBodyColor = (color: ABodyColor | string | null | undefined): ABodyColor => {
  if (!color) return DEFAULT_BODY_COLOR;
  if (Object.values(ABodyColor).includes(color as ABodyColor)) return color as ABodyColor;

  return DEFAULT_BODY_COLOR;
};
